import React, { useState, useCallback, FC } from 'react';
import { Box } from '@mui/material';

import { Day } from './day';
import { Week } from './week';
import { Month } from './month';
import { Listing } from './table';
import { CalendarView, CalendarViewComponentProps } from '../types';
import { useEventIdParam } from '../hooks';
import { EventCard } from './card';
import { CalendarPanel } from './CalendarPanel';
import { CalendarLayout } from './CalendarLayout';

export const CalendarContainer = () => {
  const { eventId } = useEventIdParam();

  const [view, setView] = useState<CalendarView>(CalendarView.Month);
  const [date, setDate] = useState<Date>(new Date());

  const handleNavigate = useCallback((nextDate: Date) => setDate(nextDate), []);

  const renderNestedSectionByMode: Record<CalendarView, FC<CalendarViewComponentProps>> = {
    [CalendarView.Day]: Day,
    [CalendarView.Week]: Week,
    [CalendarView.Month]: Month,
    [CalendarView.Table]: Listing,
  };

  const ViewComponent = renderNestedSectionByMode[view];

  return (
    <>
      {eventId && <EventCard id={eventId} />}

      <CalendarLayout>
        <CalendarPanel view={view} setView={setView} />

        <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
          <ViewComponent date={date} onNavigate={handleNavigate} />
        </Box>
      </CalendarLayout>
    </>
  );
};
